module.exports = __webpack_public_path__ + "static/media/arrow-compress-h.1c218b29.svg";